/* global System */

export default {
  EmbedExternalIFrame: () =>
    System.import(/* webpackChunkName: "EmbedExternalIFrame" */ './index'),
}
